import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';

const routes: Routes = [
  { path: '', loadChildren: () => import('./info-page/info-page.module').then(m => m.InfoPageModule) },
  { path: 'member', loadChildren: () => import('./details-page/details-page.module').then(m => m.DetailsPageModule), pathMatch:'full' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MembersRoutingModule {
  constructor(router: Router) {
  }
}
